let StreamCompanyLogoDirective = (EnvironmentConfigService, CommonLayoutService, Configs) => {
    function loadImage(scope, element, attrs) {
        setTimeout(() => {
            const attributes = ['companyLogo', 'assets'];
            const envConfig = Configs.getEnvironmentConfig();
    
            if (envConfig) {
                const arrayBuffer = envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
                if (scope.setPreviewText) CommonLayoutService.setUIConfig(envConfig.assets);
                setLogo(arrayBuffer, attrs);
            }
    
            if (!envConfig && scope.loadFromDb) {
                return EnvironmentConfigService.getUIConfigs(attributes)
                    .then((data) => {
                        const envConfig = data.results.environmentConfig;
                        const arrayBuffer = envConfig && envConfig.companyLogo ? envConfig.companyLogo['data'] : [];
                        setLogo(arrayBuffer, attrs);
                        if (scope.setPreviewText) CommonLayoutService.setUIConfig(envConfig.assets);
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }
        }, 100)
    };

    function setLogo(arrayBuffer, attrs) {
        if (!arrayBuffer.length) return;
        const objectURL = CommonLayoutService.generateObjectURL(arrayBuffer);
        attrs.$set('src', objectURL);
        CommonLayoutService.updateFavicon(arrayBuffer);
    }

    return {
        restrict: 'A',
        scope: {
            loadFromDb: '=',
            setPreviewText: '='
        },
        link: loadImage
    }
};

StreamCompanyLogoDirective.$inject = ['EnvironmentConfigService', 'CommonLayoutService', 'Configs'];

export default StreamCompanyLogoDirective;


// WEBPACK FOOTER //
// ./client/app/common/stream-company-logo/stream-company-logo.directive.js